import React, { useState } from "react";
import Cropper from "react-easy-crop";
import Button from "@mui/material/Button";
import "react-easy-crop/react-easy-crop.css";

function CropImageModal({ imageFile, onCropComplete, onClose }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropCompleteHandler = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = (err) => reject(err);
      image.setAttribute("crossOrigin", "anonymous"); // For cross-origin image issues
      image.src = url;
    });

  const getCroppedImage = async (imageSrc, cropPixels) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = cropPixels.width;
    canvas.height = cropPixels.height;

    ctx.drawImage(
      image,
      cropPixels.x,
      cropPixels.y,
      cropPixels.width,
      cropPixels.height,
      0,
      0,
      cropPixels.width,
      cropPixels.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty.");
          return;
        }
        resolve(blob);
      }, "image/jpeg");
    });
  };

  const handleCropSave = async () => {
    if (!croppedAreaPixels) {
      alert("Please adjust the crop before saving.");
      return;
    }

    try {
      const croppedBlob = await getCroppedImage(imageFile, croppedAreaPixels);
      onCropComplete(croppedBlob);
      onClose();
    } catch (error) {
      console.error("Error cropping the image:", error);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.8)", // Darker background for better focus
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          maxWidth: "800px",
          maxHeight: "90%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
        }}
      >
        <h3 style={{ marginBottom: "15px", fontSize: "20px" }}>Crop Image</h3>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "400px", // Increased height for larger crop area
            background: "#f0f0f0",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <Cropper
            image={imageFile}
            crop={crop}
            zoom={zoom}
            aspect={1} // Square aspect ratio
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropCompleteHandler}
            // Enable pinch-to-zoom
            restrictPosition={false} // Allow free panning
            cropShape="rect" // Rectangle crop
          />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", gap: "15px" }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onClose}
            style={{
              flex: 1,
              borderRadius: "8px",
              fontWeight: "bold",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCropSave}
            style={{
              flex: 1,
              backgroundColor: "#5a31f4",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: "bold",
            }}
          >
            Save Crop
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CropImageModal;
